/**
 * Tela de sessão de depuração encerrada (spec 020, US1 cenário 3). Fica também
 * depois de recarregar: a aba não vira, sem aviso, a sessão do admin que mora
 * na outra aba. "Voltar ao ERP" é o gesto explícito para isso.
 */
import { useEffect } from 'react';
import { EyeOff } from 'lucide-react';
import { leaveImpersonation, type ImpersonationEndReason } from '@/auth/impersonation';
import { queryClient } from '@/lib/query-client';
import { Button } from '@/components/ui/button';

const COPY: Record<ImpersonationEndReason, { title: string; detail: string }> = {
  ended: {
    title: 'Sessão de depuração encerrada',
    detail: 'Você encerrou a sessão. O acesso deixou de valer no servidor.',
  },
  expired: {
    title: 'A sessão de depuração expirou',
    detail: 'O prazo de 60 minutos acabou e o acesso deixou de valer.',
  },
  revoked: {
    title: 'Sessão de depuração encerrada',
    detail:
      'A API recusou o acesso: a sessão foi encerrada em outro lugar, expirou ou o usuário foi desativado.',
  },
};

export function ImpersonationEnded({ reason }: { reason: ImpersonationEndReason }) {
  // o que a aba leu como o cliente não fica na memória depois do fim
  useEffect(() => {
    queryClient.clear();
  }, []);
  const copy = COPY[reason];
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm rounded-lg border bg-card p-6 text-center shadow-sm">
        <EyeOff className="mx-auto size-8 text-muted-foreground" aria-hidden />
        <h1 className="mt-3 text-base font-semibold text-foreground">{copy.title}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{copy.detail}</p>
        <p className="mt-3 text-sm text-muted-foreground">Pode fechar esta aba.</p>
        <Button variant="outline" size="sm" className="mt-4" onClick={leaveImpersonation}>
          Voltar ao ERP
        </Button>
      </div>
    </div>
  );
}
